export const environment = {
  production: true,
  publisher: 'marietti',
  urlPortale: 'https://www.mariettieditore.it',
  // syncUrlPortale: 'https://www.mariettieditore.it/transcode/importSingleBook',
  // syncUrlPortale: 'https://www.mariettieditore.it/transcode/importSingleBookEvo',
  syncUrlPortale: 'https://www.mariettieditore.it/transcode/importbook',
  syncCoversPortale: 'https://www.mariettieditore.it/transcode/importCovers',
  server: {
    url: 'https://elzeviro-marietti.ilporticoeditoriale.it:3031'
  },
  copertinario: {
    // media: 'http://elzeviro-marietti.ilporticoeditoriale.it:3030/static/media/copertinario/',
    // make: 'http://elzeviro-marietti.ilporticoeditoriale.it:8080/copertinario/make'
    media: 'https://elzeviro-edb.ilporticoeditoriale.it:3030/static/media/copertinario/',
    make: 'https://elzeviro-edb.ilporticoeditoriale.it:8080/copertinario/make'
  },
  recensioni: {
    media: 'https://elzeviro-marietti.ilporticoeditoriale.it:3031/static/media/recensioni/'
  },
  extra: {
    media: 'https://elzeviro-marietti.ilporticoeditoriale.it:3031/static/media/extra/'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts